import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DatagridService, NotificationService, PagedResultGeneric, PagedSearch, TranslationService } from 'src/app/shared';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { PledgeService } from 'src/app/revenue/shared/pledge/pledge.service';
import { PledgeCampaignDto } from 'src/app/revenue/shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeSearchDto } from 'src/app/revenue/shared/pledge/dto/pledge-search.dto';
import { PledgeAddDialogComponent } from 'src/app/revenue/pledge/pledge-add-dialog/pledge-add-dialog.component';
import { ProfileMin } from 'src/app/profiles/shared/profile-min.model';
import { PledgeSeachResultDto } from 'src/app/revenue/shared/pledge/dto/pledge-search-result.dto';

@Component({
  selector: 'wl-pledge-campaign-pledges',
  templateUrl: './pledge-campaign-pledges.component.html',
  styleUrls: ['./pledge-campaign-pledges.component.less'],
    standalone: false
})
export class PledgeCampaignPledgesComponent implements OnInit, OnChanges {
  @Input() pledgeCampaign: PledgeCampaignDto;
  @Output() pledgeDeleted = new EventEmitter<boolean>();
  @ViewChild(PledgeAddDialogComponent) private _addDialog: PledgeAddDialogComponent;

  rowMenuItems = new Map<number, MenuItem[]>();

  showSelectProfile: boolean = false;
  selectedProfile: ProfileMin = new ProfileMin();
  searchParams: PledgeSearchDto;
  searchResult: Array<PledgeSeachResultDto>;
  busy = false;
  pageSize = 20;
  first = 0;
  exporting: boolean = false;
  constructor(
    datagridService: DatagridService,
    private _pledgeService: PledgeService,
    private _translationService: TranslationService,
    private _navigationService: NavigationService,
    private _confirmationService: ConfirmationService,
    private _notificationService: NotificationService,
    public securityElementNames: SecurityElementNames
  ) {
    this.searchParams = {} as PledgeSearchDto;
    this.searchResult = [];
  }

  ngOnInit() {
    this.search();
  }

  ngOnChanges() {
    this.searchParams.PledgeCampaignId = this.pledgeCampaign.PledgeCampaignId;
  }

  public async search() {
    this.busy = true;
    await this._pledgeService
      .searchPledges(this.searchParams)
      .then((data) => {
        this.searchResult = data.Result;
        this.first = 0;
      })
      .finally(() => {
        this.busy = false;
      });
  }

  public addPledge() {
    this.selectedProfile = new ProfileMin();
    this.showSelectProfile = true;
  }

  public profileSelectCancelled() {
    this.selectedProfile = new ProfileMin();
    this.showSelectProfile = false;
  }

  public setProfile(profile: ProfileMin) {
    this.selectedProfile = profile;
    this.showSelectProfile = false;
    this.openAddPledgeDialog();
  }

  actionItemsForPledge(pledge: PledgeSeachResultDto): MenuItem[] {
    if (!this.rowMenuItems.has(pledge.PledgeId)) {
      this.rowMenuItems.set(pledge.PledgeId, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editPledge(pledge),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deletePledge(pledge),
        },
      ]);
    }
    return this.rowMenuItems.get(pledge.PledgeId);
  }

  private editPledge(pledge: PledgeSeachResultDto) {
    this._navigationService.navigateToPledgeEdit(pledge.PledgeId);
  }

  private deletePledge(pledge: PledgeSeachResultDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstantTitlecase('revenue.pledge-campaigns.pledge-campaign.pledges.delete-message'),
      key: 'deletePledgeCD',
      accept: () => {
        this.busy = true;
        this._pledgeService.deletePledge(pledge.PledgeId).then(
          () => {
            this._notificationService.translateSuccess('revenue.pledge-campaigns.pledge-campaign.pledges.pledge-deleted');
            this.pledgeDeleted.emit(true);
            this.search();
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        );
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }

  private openAddPledgeDialog() {
    if (this.selectedProfile.ProfileId > 0) {
      this._addDialog.open();
    }
  }

  public exportPledges() {
    this.exporting = true;
    this._pledgeService
      .exportPledges(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
}
